import { NgForOf, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatOption, MatOptionSelectionChange } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { AdminService } from '../../admin/admin.service';
import { IDuplikitScheduledMergeTime } from '../../shared/interfaces/duplikit-interfaces';
import { IScheduledDedupeSettings } from '../../shared/interfaces/ischeduled-dedupe-settings';
import { ScheduledMergesService } from '../../shared/services/scheduled-merges.service';
import { UtilsService } from '../../shared/services/utils.service';

@Component({
  selector: 'app-scheduled-merges',
  templateUrl: './scheduled-merges.component.html',
  imports: [
    NgIf,
    NgForOf,
    MatCheckbox,
    FormsModule,
    MatSelect,
    MatOption
  ],
  styleUrls: ['./scheduled-merges.component.scss']
})
export class ScheduledMergesComponent implements OnInit {
  settingsLoaded = false;
  scheduleTimes: IDuplikitScheduledMergeTime[] = [];
  @Input() canSchedule: boolean;

  batchSizes = [10, 100, 250, 500, 750, 1000, 1500, 2000];

  constructor(
      public utilsService: UtilsService,
      public scheduledMergesService: ScheduledMergesService,
      private adminService: AdminService
  ) {
  }

  ngOnInit() {
    this.getSettings();
    this.populateTimes();
  }

  getSettings(): void {
    this.scheduledMergesService.getScheduledDedupeSettingsForCorp().subscribe((res: IScheduledDedupeSettings) => {
      this.scheduledMergesService.scheduledDedupeSettings = res;

      this.settingsLoaded = true;
    }, (error) => {
      console.error(error);
    });
  }

  changed() {
    this.scheduledMergesService.changesMade.next(true);
  }

  optionChanged(event: MatOptionSelectionChange) {
    if (!event.isUserInput) {
      return;
    }
    this.scheduledMergesService.changesMade.next(true);
  }

  get24hrDisplay(timeValue: number) {
    if (timeValue < 10)
      return `0${ timeValue }:00 UTC`;
    else
      return `${ timeValue }:00 UTC`;
  }

  get canEdit() {
    return !this.adminService.isInLiteMode() && this.canSchedule;
  }

  private populateTimes(): void {
    for (let i = 0; i < 24; i++) {
      this.scheduleTimes.push({ timeValue: i });
    }
  }

}
